<template>
  <main>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.status" @input="load">
          <b-tab>
            <template #title>
              {{ $t('all') }}
              <small v-if="!countLoading">({{ count[0] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('waiting') }}
              <small v-if="!countLoading">({{ count[1] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('confirmed') }}
              <small v-if="!countLoading">({{ count[2] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('canceled') }}
              <small v-if="!countLoading">({{ count[3] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('invoiceExported') }}
              <small v-if="!countLoading">({{ count[4] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('invoiceNotExported') }}
              <small v-if="!countLoading">({{ count[5] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <client-select :model="filterFormModel" attribute="client" @change="search" :isFilter="true"
                           :place-holder="$t('selectClient')" class="mr-1 mb-1"></client-select>
            <admin-user-select :model="filterFormModel" attribute="agency" roleFilter="agency" @change="search"
                               place-holder="Lọc theo đại lý" class="mr-1 mb-1" style="min-width:180px"></admin-user-select>
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="method" :options="methods"></form-select>
            <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="type" :options="[
                {value: '-1', text: this.$t('allType')},
                {value: null, text: this.$t('service')},
                {value: 'plan', text: this.$t('plan')},
                {value: 'ai', text: this.$t('ai')}
            ]"></form-select>

            <time-range-picker :model="filterFormModel" :label="$t('createTime')"
                               from-attribute="createFrom" to-attribute="createTo"
                               class="mr-1 mb-1" :default-shortcut="6"></time-range-picker>
            <time-range-picker :model="filterFormModel" :label="$t('confirmTime')"
                               from-attribute="confirmFrom" to-attribute="confirmTo"
                               class="mr-1 mb-1"></time-range-picker>

            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting"
             v-if="['admin', 'owner', 'accountant', 'account', 'operationsManager'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <credit-deposit-export :filter="filterFormModel" :total-count="itemCount"></credit-deposit-export>
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">{{ $t('client') }}</div>
            <div class="col-lg-4">{{ $t('info') }}</div>
            <div class="col-lg-3">{{ $t('invoice') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-3">
              <template v-if="item.client">
                <div>
                  <b>{{ $t('clientCode') }}: </b>
                  <span>{{ item.client.code }}</span>
                </div>

                <div>
                  <b>{{ $t('client') }}: </b>
                  <span>{{ item.client.companyName }}</span>
                </div>

                <div>
                  <b>{{ $t('domain') }}: </b>
                  <span>{{ item.client.domain }}</span>
                </div>
                <div v-if="item.client.agency" class="mt-1">
                  <span class="badge badge-warning"><font-awesome-icon icon="user-tie" class="mr-1"/>Đại lý: {{ item.client.agency.name }}</span>
                </div>

                <div>
                  <b>{{ $t('invoiceCustomerName') }}: </b>
                  <span v-if="item.client.invoiceCustomerName">{{
                      item.client.invoiceCustomerName
                    }}</span>
                  <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
                </div>

                <div>
                  <b>{{ $t('invoiceEmail') }}: </b>
                  <span v-if="item.client.invoiceEmail">{{
                      item.client.invoiceEmail.replace(/;/g, ', ')
                    }}</span>
                  <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
                </div>

                <div>
                <span v-if="item.client.manualInvoiceEnabled" class="badge badge-danger">{{
                    $t('manualInvoice')
                  }}</span>
                  <span v-else-if="item.client.invoiceEnabled" class="badge badge-success">{{ $t('vat') }}</span>
                  <span v-else class="badge badge-warning">{{ $t('customer') }}</span>
                </div>
              </template>

              <p v-if="item.plan" class="mt-2">
                <b>{{ $t("planOrder") }}: </b>
                {{ $t(`${item.plan.type}PlanOrderType`) }}
                {{ item.plan.type === 'upgrade' ? $t('oldPlan').toLowerCase() : $t('planName').toLowerCase() }}
                <span v-if="item.plan.plan"> <b>{{ item.plan.plan.name }}</b></span>
                <span
                    v-if="item.plan.upgradedPlan"> {{
                    $t('upgradedPlan').toLowerCase()
                  }}&nbsp;<b>{{ item.plan.upgradedPlan.name }}</b></span>
                -
                <label v-if="!item.plan.cancelTime && !item.plan.confirmTime" class="text-warning">{{
                    $t('waiting')
                  }}</label>
                <label v-if="item.plan.confirmTime" class="text-success">{{ $t('confirmed') }}</label>
                <label v-if="item.plan.cancelTime" class="text-dark">{{ $t('canceled') }}</label>
              </p>

              <div v-if="item.aiPackage" class="mt-2">
                <b>{{ $t(`${item.aiPackage.type}AIAgent`) }}:</b>
                {{ $t('monthCount').toLowerCase() }} {{ item.aiPackage.monthCount }},
                {{ $t('numberOfChatbot').toLowerCase() }} {{ item.aiPackage.limit }}
                -
                <label v-if="!item.aiPackage.cancelTime && !item.aiPackage.confirmTime"
                       class="text-warning">{{ $t('waiting') }}</label>
                <label v-if="item.aiPackage.confirmTime" class="text-success">{{ $t('confirmed') }}</label>
                <label v-if="item.aiPackage.cancelTime" class="text-dark">{{ $t('canceled') }}</label>
              </div>

              <div v-if="item.invoicePackage" class="mt-2">
                <b>{{ $t(`${item.invoicePackage.type}InvoicePlanOrderType`) }} </b>
                <div v-if="item.invoicePackage.plan && item.invoicePackage.type !== 'esign'">
                  {{ item.invoicePackage.plan.name }}
                </div>
                <div v-if="item.invoicePackage.isEsign && item.invoicePackage.esignYearCount">
                  {{ $t('esignOfYear').toLowerCase() }} {{ item.invoicePackage.esignYearCount }}
                  {{ $t('year').toLowerCase() }}
                </div>
                <div>
                  <label v-if="!item.invoicePackage.cancelTime && !item.invoicePackage.confirmTime"
                         class="text-warning">{{ $t('waiting') }}</label>
                  <label v-if="item.invoicePackage.confirmTime" class="text-success">{{ $t('confirmed') }}</label>
                  <label v-if="item.invoicePackage.cancelTime" class="text-dark">{{ $t('canceled') }}</label>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <p>
                <span :class="getClass(item)">{{ getStatus(item) }}</span>
              </p>
              <div>
                <b>{{ $t('amount') }}: </b>
                <span class="text-success">{{ item.amount | numFormat }} {{ item.client.country.currency }}</span>
              </div>
              <div>
                <b>{{ $t('content') }}: </b>
                <span>{{ item.content }}</span>
                <span v-if="!item.content" class="text-danger">{{ $t('na') }}</span>
              </div>
              <div>
                <b>{{ $t('method') }}: </b>
                <span class="text-primary">{{ $t(item.method) }}</span>
              </div>
              <div>
                <b>{{ $t('ref') }}: </b>
                <span>{{ item.ref }}</span>
                <span v-if="!item.ref" class="text-danger small">{{ $t('notUpdated') }}</span>
              </div>
              <div v-if="item.errorCode">
                <b>{{ $t('errorCode') }}: </b>
                <span>{{ item.errorCode }}</span>
              </div>
              <div v-if="item.errorMsg">
                <b>{{ $t('errorMsg') }}: </b>
                <span class="text-danger">{{ item.errorMsg }}</span>
              </div>

            </div>
            <div class="col-lg-3">
              <div>
                <b>{{ $t('createTime') }}: </b>
                <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </div>
              <div v-if="item.confirmTime">
                <b>{{ $t('confirmTime') }}: </b>
                <span>{{ item.confirmTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </div>
              <div v-if="item.confirmedBy">
                <b>{{ $t('confirmedBy') }}: </b>
                <span>{{ item.confirmedBy.name }}</span>
              </div>
              <div v-if="item.cancelTime">
                <b>{{ $t('cancelTime') }}: </b>
                <span>{{ item.cancelTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </div>
              <div><span class="badge badge-info" v-if="!item.client.manualInvoiceEnabled && item.manualInvoice">Xuất về cá nhân nếu là doanh nghiệp</span>
              </div>
              <div class="mb-2">
                <span class="badge badge-warning" v-if="!invoiceEnabled || item.client.manualInvoiceEnabled">Xuất hoá đơn thủ công</span>
                <span class="badge badge-success" v-else>Xuất hoá đơn tự động</span>

                <span v-if="item.type === 'plan'" class="badge badge-primary ml-1">{{ $t('plan') }}</span>
                <span v-else-if="item.type === 'ai'" class="badge badge-primary ml-1">{{ $t('ai') }}</span>
                <span v-else-if="item.type === 'invoice'" class="badge badge-primary ml-1">{{
                    $t('invoiceType')
                  }}</span>
                <span v-else class="badge badge-success ml-1">{{ $t('service') }}</span>
              </div>
              <template
                  v-if="!item.client.manualInvoiceEnabled && item.confirmTime && item.invoice && (!item.invoice.error && !item.invoice.no)">
                <div>
                  <span class="text-warning">Chờ xuất hoá đơn...</span>
                </div>
              </template>
              <template v-if="!item.client.manualInvoiceEnabled && item.confirmTime && item.invoice">
                <div v-if="item.invoice.no">
                  <b>Số hoá đơn: </b>
                  <span>{{ item.invoice.no }}</span>
                </div>
                <div v-if="item.invoice.date">
                  <b>Ngày xuất: </b>
                  <span>{{ item.invoice.date }}</span>
                </div>
                <div v-if="item.invoice.keySearch">
                  <b>Mã tra cứu: </b>
                  <span>{{ item.invoice.keySearch }}</span>
                </div>
                <div v-if="item.invoice.error || item.invoice.errorMsg">
                  <b>{{ item.invoice.error ? $t('errorMsg') : "Trạng thái" }}: </b>
                  <span :class="[item.invoice.error ? 'text-danger' : '']">{{ item.invoice.errorMsg }}</span>
                </div>
                <div v-if="item.invoice.status">
                  <b>Trạng thái hoá đơn: </b>
                  <span>{{ item.invoice.status }}</span>
                </div>
                <div v-if="item.invoice.orderCode">
                  <b>Đơn hàng: </b>
                  <span>{{ item.invoice.orderCode }}</span>
                </div>
                <div v-if="item.invoice.keySearch">
                  <a :href="`${serviceUrl}/webhook-invoice/${item._id}`" target="_blank">Chi tiết hoá đơn</a>
                </div>

              </template>
            </div>
            <div class="col-lg-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2"
                     v-if="['admin', 'owner', 'accountant', 'operationsManager', 'account'].includes($store.state.user.role)">
                  <div v-if="!item.client.manualInvoiceEnabled && item.confirmTime && item.invoice">
                    <button v-if="item.invoice.error || !item.invoice.no" @click="exportInvoice(item._id)" type="button"
                            class="btn btn-sm btn-warning mr-1">
                      <i class="fa fa-file-pdf-o"></i>
                      {{ $t('exportInvoice') }}
                    </button>
                    <!-- <button v-else-if="item.invoice.keySearch" @click="checkInvoice(item._id)" type="button"
                            class="btn btn-sm btn-primary mr-1">
                      <i class="fa fa-refresh"></i>
                      {{ $t('statusInvoice') }}
                    </button> -->
                  </div>
                  <div v-if="item.method === 'bank' && !item.confirmTime && !item.cancelTime"
                       class="c-buttons__col">
                    <button @click="update(item._id)" type="button"
                            class="btn btn-sm btn-warning mr-1">
                      <font-awesome-icon icon="check"/>&nbsp;{{ $t('confirm') }}
                    </button>
                  </div>
                  <button v-if="!item.confirmTime && !item.cancelTime" @click="cancel(item._id)" type="button"
                          class="btn btn-sm btn-danger mr-1">
                    <font-awesome-icon icon="window-close"/>&nbsp;{{ $t('cancel') }}
                  </button>
                  <div class="c-buttons__col" v-if="item.method === 'alepay' && !item.confirmTime">
                    <button @click="updateStatusAlepay(item._id)" type="button" :disabled='updateStatusLoading'
                            class="btn btn-sm btn-warning mr-1">
                      <b-spinner small v-if="updateStatusLoading"></b-spinner>
                      <font-awesome-icon icon="check" v-else/>&nbsp;{{ $t('updateStatus') }}
                    </button>
                  </div>
                  <div class="c-buttons__col" v-if="item.method === 'vnpay'">
                    <button v-if="item.cancelTime" @click="updateStatusVnpay(item._id)" type="button"
                            :disabled='updateStatusLoading' class="btn btn-sm btn-warning mr-1">
                      <b-spinner small v-if="updateStatusLoading"></b-spinner>
                      <font-awesome-icon icon="check" v-else/>&nbsp;{{ $t('updateStatus') }}
                    </button>
                  </div>
                  <div class="c-buttons__col" v-if="item.method === 'momo'">
                    <button v-if="item.cancelTime || item.errorCode == 150" @click="updateStatusMomo(item._id)"
                            type="button" :disabled='updateStatusLoading' class="btn btn-sm btn-warning mr-1">
                      <b-spinner small v-if="updateStatusLoading"></b-spinner>
                      <font-awesome-icon icon="check" v-else/>&nbsp;{{ $t('updateStatus') }}
                    </button>
                  </div>
                  <button type="button" class="btn btn-sm btn-info mr-1" @click="openInvoiceInfo(item.client._id)">
                    <font-awesome-icon icon="list"/>
                    {{ $t('invoiceInfo') }}
                  </button>
                  <button type="button" class="btn btn-sm btn-info mr-1" @click="updateInvoiceInfo(item._id)">
                    <font-awesome-icon icon="edit"/>
                    {{ $t('updateInvoiceInfo') }}
                  </button>
                  <button v-if="['owner'].includes($store.state.user.role) && item.confirmTime" type="button"
                          class="btn btn-sm btn-info mr-1" @click="updateConfirmTime(item._id)">
                    <font-awesome-icon icon="edit"/>
                    {{ $t('updateConfirmTime') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" :title="formTitle" no-close-on-backdrop no-enforce-focus>
      <client-select :disabled="formModel.id" :label="$t('client')" :model="formModel" :errors="formErrors"
                     attribute="client"></client-select>
      <form-select :disabled="formModel.id" :label="$t('type')" :model="formModel" attribute="type" :errors="formErrors"
                   :options="typeOptions"></form-select>
      <form-input :disabled="formModel.confirmTime ? true : false" :label="$t('amount')" :model="formModel"
                  attribute="amount"
                  :errors="formErrors"></form-input>
      <div>
        <label class="form-label d-block">
          {{ $t('content') }}
          <small class="text-secondary d-block mt-1">{{ $t('noteContent') }}</small>
        </label>
        <form-input :label="null" :model="formModel" attribute="content" :errors="formErrors" :disabled="formModel.id"/>
      </div>
      <form-select :disabled="formModel.id" :label="$t('method')" :model="formModel" attribute="method"
                   :errors="formErrors" :options="methods"></form-select>
      <form-input :label="$t('ref')" :model="formModel" attribute="ref" :errors="formErrors"></form-input>
      <form-checkbox chk-label="Xuất về cá nhân nếu là doanh nghiệp" :model="formModel" attribute="invoiceEnabled"
                     :errors="formErrors"></form-checkbox>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="float-right" @click="showForm = false">{{ $t('cancel') }}</b-button>
        <b-button variant="primary" class="float-right" @click="saveCreditDeposit(false)">
          {{ $t('save') }}
        </b-button>
        <b-button variant="success" class="float-right" @click="saveCreditDeposit(true)">
          {{ $t('confirmNow') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal v-model="showInvoiceForm" :title="formTitle" no-close-on-backdrop no-enforce-focus>
      <form-checkbox :disabled=true :chk-label="$t('vat')" :model="formModel" attribute="invoiceEnabled"
                     :errors="formErrors"/>
      <form-input :disabled=true :label="$t('invoiceCustomerName')" :model="formModel" :errors="formErrors"
                  attribute="invoiceCustomerName"/>
      <form-input :disabled=true :label="$t('invoiceCompanyName')" :model="formModel" :errors="formErrors"
                  attribute="invoiceCompanyName"/>
      <form-input :disabled=true :label="$t('invoiceTaxCode')" :model="formModel" :errors="formErrors"
                  attribute="invoiceTaxCode"/>
      <form-input :disabled=true :label="$t('invoiceIdentity')" :model="formModel" :errors="formErrors"
                  attribute="invoiceIdentity"/>
      <form-input :disabled=true :label="$t('invoiceAddress')" :model="formModel" :errors="formErrors"
                  attribute="invoiceAddress"/>
      <form-array :disabled=true :label="$t('invoiceEmail')" :model="formModel" :errors="formErrors"
                  attribute="invoiceEmailArray"/>
      <form-date-time :disabled=true :label="$t('invoiceStartTime')" :model="formModel" :errors="formErrors"
                      attribute="invoiceStartTime" format="DD/MM/YYYY HH:mm:ss"></form-date-time>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="float-right" @click="showInvoiceForm = false">
          {{ $t('cancel') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal v-model="showInvoiceInfoForm" :title="formTitle" no-close-on-backdrop no-enforce-focus>
      <form-checkbox :chk-label="$t('invoiceManual')" :model="invoiceInfoFormModel" attribute="manual"
                     :errors="invoiceInfoFormErrors"></form-checkbox>
      <form-input :label="$t('invoicePattern')" :model="invoiceInfoFormModel" attribute="pattern"
                  :errors="invoiceInfoFormErrors"/>
      <form-input :label="$t('invoiceSerial')" :model="invoiceInfoFormModel" attribute="serial"
                  :errors="invoiceInfoFormErrors"/>
      <form-input :label="$t('invoiceNo')" :model="invoiceInfoFormModel" attribute="no"
                  :errors="invoiceInfoFormErrors"/>
      <form-input :label="$t('invoiceDate')" :model="invoiceInfoFormModel" attribute="date"
                  :errors="invoiceInfoFormErrors"/>
      <form-input :label="$t('invoiceVerificationCode')" :model="invoiceInfoFormModel" attribute="verificationCode"
                  :errors="invoiceInfoFormErrors"/>
      <form-input :label="$t('invoiceKeySearch')" :model="invoiceInfoFormModel" attribute="keySearch"
                  :errors="invoiceInfoFormErrors"/>
      <form-input :label="$t('invoiceStatus')" :model="invoiceInfoFormModel" attribute="status"
                  :errors="invoiceInfoFormErrors"/>
      <form-input :label="$t('invoiceOrderCode')" :model="invoiceInfoFormModel" attribute="orderCode"
                  :errors="invoiceInfoFormErrors"/>

      <template v-slot:modal-footer>
        <b-button variant="secondary" class="float-right" @click="showInvoiceInfoForm = false">{{
            $t('cancel')
          }}
        </b-button>
        <b-button variant="primary" class="float-right" @click="saveInvoiceInfo">
          {{ $t('save') }}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showFormUpdateConfirmTime" :title="formTitle" no-close-on-backdrop no-enforce-focus>
      <form-date-time :label="$t('createTime')" :model="formModel" attribute="createTime"
                      :errors="formErrors" format="DD/MM/YYYY HH:mm:ss"></form-date-time>
      <form-date-time :label="$t('confirmTime')" :model="formModel" attribute="confirmTime"
                      :errors="formErrors" format="DD/MM/YYYY HH:mm:ss"></form-date-time>

      <template v-slot:modal-footer>
        <b-button variant="secondary" class="float-right" @click="showFormUpdateConfirmTime = false">{{
            $t('cancel')
          }}
        </b-button>
        <b-button variant="primary" class="float-right" @click="saveConfirmTime">
          {{ $t('save') }}
        </b-button>
      </template>
    </b-modal>
  </main>
</template>
<script>
import List from '@/mixins/List';
import CRUD from "@/mixins/CRUD";
import ClientSelect from "@/components/ClientSelect";
import AdminUserSelect from "@/components/AdminUserSelect";
import TimeRangePicker from "@/components/TimeRangePicker";
import CreditDepositExport from "./CreditDepositExport";
import _ from 'lodash';
import console from 'console';
import moment from 'moment';

export default {
  components: {
    CreditDepositExport,
    TimeRangePicker,
    ClientSelect,
    AdminUserSelect
  },
  mixins: [List, CRUD],
  data: function () {
    return {
      serviceUrl: process.env.VUE_APP_SERVICE_URL,
      service: '/credit-deposit',
      defaultFormModel: {
        type: null,
        client: this.client ? this.client._id : null,
        method: 'bank',
        invoiceEnabled: true,
      },
      defaultFilterFormModel: {
        type: "-1",
        status: 1,
        client: this.client ? this.client._id : null,
        method: null,
        createFrom: moment().startOf('month').valueOf(),
        createTo: moment().endOf('month').valueOf(),
      },
      updateStatusLoading: false,
      methods: [
        {value: null, text: this.$t('allMethods')},
        {value: 'bank', text: this.$t('bank')},
        // {value: 'alepay', text: this.$t('alepay')},
        {value: 'momo', text: this.$t('momo')},
        // {value: 'vnpay', text: this.$t('vnpay')},
      ],
      typeOptions: [
        {value: null, text: this.$t('service')},
        {value: 'plan', text: this.$t('plan')},
        {value: 'ai', text: this.$t('ai')},
        {value: 'invoice', text: this.$t('invoiceType')},
      ],
      invoiceEnabled: false,
      showInvoiceForm: false,
      count: {},
      countLoading: false,
      afterLoad: () => {
        this.getCount();
      },
      invoiceInfoFormModel: {
        manual: true,
        pattern: null,
        serial: null,
        no: null,
        date: null,
        verificationCode: null,
        keySearch: null,
        status: null,
        orderCode: null,
      },
      invoiceInfoFormErrors: [],
      showInvoiceInfoForm: false,
      showFormUpdateConfirmTime: false,
    }
  },
  methods: {
    update: function (id) {
      let loader = this.$loading.show();
      this.$service.get(this.service + '/' + id).then(response => {
        this.formModel = {};
        this.formTitle = this.$t('update');
        this.formErrors = [];
        this.showForm = true;
        this.formModel = response.data;
        this.formModel.amount = Math.round(this.formModel.amount);
        this.formModel.id = id;
        this.formModel.invoiceEnabled = !this.formModel.manualInvoice;
      }).finally(() => {
        loader.hide();
      });
    },
    updateConfirmTime: function (id) {
      let loader = this.$loading.show();
      this.$service.get(this.service + '/' + id).then(response => {
        this.formModel = {};
        this.formTitle = this.$t('updateConfirmTime');
        this.formErrors = [];
        this.showFormUpdateConfirmTime = true;
        this.formModel = response.data;
        this.formModel.id = id;
      }).finally(() => {
        loader.hide();
      });
    },
    updateInvoiceInfo: function (id) {
      let loader = this.$loading.show();
      this.$service.get(this.service + '/' + id).then(response => {
        this.invoiceInfoFormModel = {};
        this.formTitle = this.$t('updateInvoiceInfo');
        this.invoiceInfoFormErrors = [];
        this.showInvoiceInfoForm = true;
        this.invoiceInfoFormModel = response.data && response.data.invoice ? response.data.invoice : {};
        this.invoiceInfoFormModel.id = id;
      }).finally(() => {
        loader.hide();
      });
    },
    saveInvoiceInfo: function (evt) {
      if (evt) {
        evt.preventDefault();
      }
      let loader = this.$loading.show();
      let method = 'put';
      let url = this.service + '/invoice-info/' + this.invoiceInfoFormModel.id;
      this.$service({url: url, method: method, data: this.invoiceInfoFormModel}).then(response => {
        this.showInvoiceInfoForm = false;
        if (this.load) {
          this.load();
        }
        if (this.reloadBus) {
          this.$bus.$emit(this.reloadBus);
        }
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t(this.invoiceInfoFormModel.id ? 'updated' : 'created'),
            icon: 'success'
          });
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t(this.invoiceInfoFormModel.id ? 'updateFailed' : 'createFailed'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
          this.showInvoiceInfoForm = false;
        } else {
          this.invoiceInfoFormErrors = error.response.data;
        }
      }).finally(() => {
        loader.hide();
      });
    },
    saveConfirmTime: function (evt) {
      if (evt) {
        evt.preventDefault();
      }
      let loader = this.$loading.show();
      let method = 'put';
      let url = this.service + '/confirm-time/' + this.formModel.id;
      this.$service({url: url, method: method, data: this.formModel}).then(response => {
        this.showFormUpdateConfirmTime = false;
        if (this.load) {
          this.load();
        }
        if (this.reloadBus) {
          this.$bus.$emit(this.reloadBus);
        }
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t('updated'),
            icon: 'success'
          });
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t('updateFailed'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
          this.showFormUpdateConfirmTime = false;
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        loader.hide();
      });
    },
    openInvoiceInfo(id) {
      let loader = this.$loading.show();
      this.$service.get('/invoice-info/' + id).then(response => {
        this.formModel = {};
        this.formTitle = this.$t('invoiceInfo');
        this.formErrors = [];
        this.showInvoiceForm = true;
        this.formModel = response.data;
      }).finally(() => {
        loader.hide();
      });
    },
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    saveCreditDeposit(confirm) {
      this.formModel.confirm = confirm;
      this.save();
    },
    cancel: function (id) {
      this.$swal({
        title: this.$t('cancelDeposit'),
        icon: "info",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          this.$service.post('/credit-deposit/cancel/' + id).then(response => {
            if (response.data) {
              this.$swal({
                title: this.$t('cancelSuccess'),
                icon: 'success'
              });
              this.load()
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                title: this.$t('error'),
                text: error.response.data.message,
                icon: 'error'
              });
            }
          })
        }
      })
    },
    updateStatusAlepay(id) {
      this.updateStatusLoading = true;
      this.$service.put('/credit-deposit/update-status-alepay/' + id).then(response => {
        if (response && response.data && response.data.code) {
          if (response.code === '000') {
            this.$swal({
              icon: 'success',
              text: this.$t('depositConfirmed')
            }).then(() => {
              this.formModel.status = 0;
              this.load();
            })
          } else {
            this.load();
          }
        } else {
          this.$swal({
            icon: 'error',
            text: this.$t('errorGettingTransactionInfo')
          })
        }
      }).catch(e => {
        if (e.response && e.response.data && e.response.data.message) {
          this.$swal({
            icon: 'error',
            text: e.response.data.message
          })
        }
        console.log(e)
      }).finally(() => {
        this.updateStatusLoading = false;
      })
    },
    updateStatusVnpay(id) {
      this.updateStatusLoading = true;
      this.$service.put('/credit-deposit/update-status-vnpay/' + id).then(response => {
        if (response && response.data.RspCode === '00') {
          this.$swal({
            icon: 'success',
            text: this.$t('depositConfirmed')
          }).then(() => {
            this.formModel.status = 0;
            this.load();
          })
        } else {
          this.$swal({
            icon: 'error',
            text: response.data.Message === 'Request_is_duplicate' ? 'Giới hạn gọi API của VNPAY trên lần 5 phút. vui lòng chờ' : response.data.Message
          })
        }
      }).catch(e => {
        if (e.response && e.response.data && e.response.data.message) {
          this.$swal({
            icon: 'error',
            text: e.response.data.message
          })
        }
        console.log(e)
      }).finally(() => {
        this.updateStatusLoading = false;
      })
    },
    updateStatusMomo(id) {
      this.updateStatusLoading = true;
      this.$service.put('/credit-deposit/update-status-momo/' + id).then(response => {
        if (response && response.data.RspCode === '00') {
          this.$swal({
            icon: 'success',
            text: this.$t('depositConfirmed')
          }).then(() => {
            this.formModel.status = 0;
            this.load();
          })
        } else {
          this.$swal({
            icon: 'error',
            text: response.data.Message
          })
        }
      }).catch(e => {
        if (e.response && e.response.data && e.response.data.message) {
          this.$swal({
            icon: 'error',
            text: e.response.data.message
          })
        }
        console.log(e)
      }).finally(() => {
        this.updateStatusLoading = false;
      })
    },
    getStatus(item) {
      if (item.cancelTime) {
        return this.$t('canceled')
      } else if (item.confirmTime) {
        return this.$t('confirmed')
      } else if (item.method === 'bank') {
        return this.$t('waiting')
      } else if (!item.errorCode) {
        return this.$t('unfinished')
      } else if (item.errorCode === '150') {
        return this.$t('waiting')
      }
      return this.$t('undefined')
    },
    getClass(item) {
      if (item.cancelTime) return 'badge badge-dark'
      if (item.confirmTime) return 'badge badge-success'
      return 'badge badge-warning'
    },
    exportInvoice: function (id) {
      this.$swal({
        title: "Bạn chắc chắn muốn xuất lại hoá đơn cho lệnh nạp tiền này?",
        icon: "info",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          this.$service.put('/credit-deposit/invoice/' + id).then(response => {
            if (response.data) {
              this.$swal({
                title: "Yêu cầu xuất hoá đơn thành công",
                icon: 'success'
              });
              this.load()
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                title: this.$t('error'),
                text: error.response.data.message,
                icon: 'error'
              });
            }
          })
        }
      })
    },
    checkInvoice: function (id) {
      this.$swal({
        title: "Bạn chắc chắn muốn đồng bộ trạng thái đơn cho lệnh nạp tiền này?",
        icon: "info",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          this.$service.get('/credit-deposit/invoice/' + id).then(response => {
            if (response.data) {
              this.$swal({
                title: "Đồng bộ hoá đơn thành công",
                icon: 'success'
              });
              this.load()
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                title: this.$t('error'),
                text: error.response.data.message,
                icon: 'error'
              });
            }
          })
        }
      })
    },
    getCount() {
      this.countLoading = true;
      this.$service.get(this.service + '/count', {params: this.filterFormModel})
          .then(response => {
            this.count = response.data;
          })
          .catch(() => {
            this.count = {};
          })
          .finally(() => {
            this.countLoading = false;
          })
    },
  },
  mounted() {
    this.$bgService.get('/etc', {params: {page: 1, pageSize: 20, keyword: "invoice-enabled"}})
        .then(response => {
          response.data.docs.forEach(etc => {
            switch (etc.key) {
              case 'invoice-enabled':
                this.invoiceEnabled = Number(etc.value) === 1;
                break;
            }
          })
        });
  },
  i18n: {
    messages: {
      en: {
        waiting: 'Waiting',
        waitConfirm: 'Waiting',
        confirmed: 'Confirmed',
        canceled: 'Canceled',
        info: 'Deposit info',
        amount: 'Amount',
        content: 'Content',
        method: 'Method',
        ref: 'Ref',
        na: 'Not available',
        notUpdated: 'Not updated',
        createTime: 'Create time',
        confirmTime: 'Confirm time',
        cancelTime: 'Cancel time',
        bank: 'Bank transfer',
        nganluong: 'Ngan Luong',
        momo: 'Momo',
        cancel: 'Cancel',
        confirm: 'Confirm',
        confirmDeposit: 'Are you sure to confirm this deposit?',
        confirmSuccess: 'Deposit confirmed!',
        cancelDeposit: 'Are you sure to cancel this deposit?',
        cancelSuccess: 'Deposit canceled!',
        error: 'Error!',
        save: 'Save',
        confirmNow: 'Confirm now',
        alepay: 'Alepay',
        unfinished: 'Unfinished',
        depositConfirmed: 'Deposit confirmed',
        errorGetingTransactionInfo: 'Error geting transaction info from Alepay',
        errorCode: 'Error code',
        errorMsg: 'Error message',
        updateStatus: 'Update status',
        allMethods: 'All methods',
        vnpay: "VnPay",
        confirmedBy: "Confirmed by",
        plan: "Plan order",
        service: "Service",
        allType: "Phân loại: Tất cả",
        newPlanOrderType: "Mới",
        "upgradePlanOrderType": "Nâng cấp gói dịch vụ",
        "extendPlanOrderType": "Gia hạn gói dịch vụ",
        "userPlanOrderType": "Mua thêm tài khoản",
        "unlimitedPlanOrderType": "Sử dụng gói \"Không giới hạn\"",
        "oldPlan": "Gói dịch vụ cũ",
        "upgradedPlan": "Gói dịch vụ mới",
        "planName": "Tên gói",
        "planOrder": "Gói dịch vụ",
        "invoice": "Hoá đơn",
        "exportInvoice": "Xuất hoá đơn",
        statusInvoice: "Đồng bộ hoá đơn",
        "aiPackage": "Nhân viên AI",
        "monthCount": "Số tháng",
        "numberOfChatbot": "Số nhân viên",
        ai: "Nhân viên AI - KCT",
        "newAIAgent": "Mua mới nhân viên AI",
        "extendAIAgent": "Gia hạn nhân viên AI",
        "userAIAgent": "Mua thêm nhân viên AI",
        invoiceExported: "Invoice exported",
        invoiceNotExported: "Invoice not exported",
        noteContent: "Note: Please provide detailed content",
        manualInvoice: "Manual Invoice",
        invoiceCustomerName: "Invoice Customer Name",
        vat: "VAT",
        customer: "Customer",
        invoiceInfo: "Invoice Info",
        invoiceCompanyName: "Invoice Company Name",
        invoiceTaxCode: "Invoice Tax Code",
        invoiceIdentity: "Invoice Identity",
        invoiceAddress: "Invoice Address",
        invoiceEmail: "Invoice Email",
        invoiceStartTime: "Invoice Start Time",
        invoiceType: "Hoá đơn điện tử - KCT",
        "newInvoicePlanOrderType": "Register to issue electronic invoices",
        "extendInvoicePlanOrderType": "Buy additional electronic invoices",
        "esignInvoicePlanOrderType": "Buy digital signature",
        "esignOfYear": "Buy digital signature",
        "year": "year",
        "clientCode": "Client code",
        updateInvoiceInfo: "Update invoice information",
        invoiceManual: "Enter manually",
        invoicePattern: "Electronic invoice form number",
        invoiceSerial: "Electronic invoice symbol",
        invoiceNo: "Electronic invoice number",
        invoiceDate: "Invoice date",
        invoiceVerificationCode: "Tax authority code issued for invoice",
        invoiceKeySearch: "invoice lookup keywords",
        invoiceStatus: "Status",
        invoiceOrderCode: "Order code",
        updateConfirmTime: "Update confirm time",
      },
      vi: {
        waiting: 'Đợi duyệt',
        waitConfirm: 'Đợi xác nhận',
        confirmed: 'Đã xác nhận',
        canceled: 'Đã huỷ',
        info: 'Thông tin lệnh chuyển tiền',
        amount: 'Số tiền',
        content: 'Nội dung',
        method: 'Phương thức',
        ref: 'Ref',
        na: 'Không có',
        notUpdated: 'Chưa cập nhật',
        createTime: 'Tạo lúc',
        confirmTime: 'Xác nhận lúc',
        cancelTime: 'Huỷ lúc',
        bank: 'Chuyển khoản',
        nganluong: 'Ngân lượng',
        momo: 'Momo',
        cancel: 'Hủy',
        confirm: 'Xác nhận',
        confirmDeposit: 'Bạn có chắc muốn xác nhận lệnh nạp tiền này?',
        confirmSuccess: 'Xác nhận lệnh nạp tiền thành công!',
        cancelDeposit: 'Bạn có chắc muốn hủy lệnh nạp tiền này?',
        cancelSuccess: 'Lệnh nạp tiền đã bị hủy!',
        error: 'Có lỗi xảy ra!',
        save: 'Lưu lại',
        confirmNow: 'Xác nhận ngay',
        alepay: 'Alepay',
        unfinished: 'Chưa hoàn thành',
        depositConfirmed: 'Lệch nạp tiền được xác nhận',
        errorGetingTransactionInfo: 'Có lỗi trong quá trình lấy thông tin từ Alepay',
        errorCode: 'Mã lỗi',
        errorMsg: 'Mô tả lỗi',
        updateStatus: 'Cập nhật trạng thái',
        allMethods: 'Tất cả các phương thức',
        vnpay: "VnPay",
        confirmedBy: "Xác nhận bởi",
        plan: "Mua gói - KCT",
        ai: "Nhân viên AI - KCT",
        service: "Dịch vụ - 10%",
        invoiceType: "Hoá đơn điện tử - KCT",
        allType: "Phân loại: Tất cả",
        newPlanOrderType: "Mới",
        "upgradePlanOrderType": "Nâng cấp gói dịch vụ",
        "extendPlanOrderType": "Gia hạn gói dịch vụ",
        "userPlanOrderType": "Mua thêm tài khoản",
        "unlimitedPlanOrderType": "Sử dụng gói \"Không giới hạn\"",
        "oldPlan": "Gói dịch vụ cũ",
        "upgradedPlan": "Gói dịch vụ mới",
        "planName": "Tên gói",
        "planOrder": "Gói dịch vụ",
        "invoice": "Thông tin hoá đơn",
        "exportInvoice": "Xuất hoá đơn",
        statusInvoice: "Đồng bộ hoá đơn",
        "aiPackage": "Nhân viên AI",
        "monthCount": "Số tháng",
        "numberOfChatbot": "Số nhân viên",
        "newAIAgent": "Mua mới nhân viên AI",
        "extendAIAgent": "Gia hạn nhân viên AI",
        "userAIAgent": "Mua thêm nhân viên AI",
        invoiceExported: "Đã xuất hóa đơn",
        invoiceNotExported: "Chưa xuất hóa đơn",
        noteContent: "Ghi chú: Cần phải nhập cụ thể nội dung",
        manualInvoice: "Xuất hóa đơn thủ công",
        invoiceCustomerName: "Tên người mua hàng",
        vat: "Xuất hóa đơn VAT",
        customer: "Khách lẻ",
        invoiceInfo: "Thông tin xuất hóa đơn",
        invoiceCompanyName: "Tên đơn vị",
        invoiceTaxCode: "Mã số thuế",
        invoiceIdentity: "Số CCCD",
        invoiceAddress: "Địa chỉ",
        invoiceEmail: "Email nhận hóa đơn",
        invoiceStartTime: "Thời gian bắt đầu xuất hóa đơn",
        "newInvoicePlanOrderType": "Đăng ký phát hành hoá đơn điện tử",
        "extendInvoicePlanOrderType": "Mua thêm hoá đơn điện tử",
        "esignInvoicePlanOrderType": "Mua chữ ký số",
        "esignOfYear": "Mua chữ ký số",
        "year": "năm",
        "clientCode": "Mã khách hàng",
        updateInvoiceInfo: "Cập nhật thông tin xuất hoá đơn",
        invoiceManual: "Nhập thủ công",
        invoicePattern: "Mẫu số hoá đơn điện tử",
        invoiceSerial: "Ký hiệu hoá đơn điện tử",
        invoiceNo: "Số hoá đơn điện tử",
        invoiceDate: "Ngày hoá đơn",
        invoiceVerificationCode: "Mã cơ quan thuế cấp cho hoá đơn",
        invoiceKeySearch: "Khoá tra cứu hoá đơn",
        invoiceStatus: "Tình trạng",
        invoiceOrderCode: "Mã đơn hàng",
        updateConfirmTime: "Cập nhật ngày xác nhận",
      }
    }
  }
}
</script>